import { createRouter, createWebHistory } from 'vue-router'

import { checkHestiaCustomersFeatureFlag } from '@/features/app-store/router/guards/checkHestiaCustomersFeatureFlag'
import { checkConversionCardsFeatureFlag } from '@/features/conversion-cards/router/guards/checkConversionCardsFeatureFlag'
import { checkGiftCardImportFeatureFlag } from '@/features/gift-cards/router/guards/checkGiftCardImportFeatureFlag'
import { checkInternalInboxFeatureFlag } from '@/features/inbox/router/guards/checkInternalInboxFeatureFlag'
import { checkLaunchFeatureFlag } from '@/features/launch'
import { checkMarketingOverviewV2FeatureFlag } from '@/features/marketing/router/guards/checkMarketingOverviewV2FeatureFlag'
import { checkMenuScorecardFeatureFlag } from '@/features/menu/router/guards/checkMenuScorecardFeatureFlag'
import { checkMenuFixerAgentFeatureFlag } from '@/features/menu-fixer-agent/router/guards/checkMenuFixerAgentFeatureFlag'
import { checkSalesFeatureFlag } from '@/features/sales/router/guards/checkSalesFeatureFlag'
import { checkPhoneOrderingFeatureFlag } from '@/features/tools/router/guards/checkPhoneOrderingFeatureFlag'
import { sendPageLoad } from '@/plugins/analytics'

import { checkAuthenticated } from './guards/checkAuthenticated'
import { checkPermissions } from './guards/checkPermissions'
import { ensureLocationIdParam } from './guards/ensureLocationIdParam'
import routes from './routes'

export const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: 'is-active',
  routes,
})

const guards = [
  checkAuthenticated,
  checkPermissions,
  checkConversionCardsFeatureFlag,
  checkGiftCardImportFeatureFlag,
  checkHestiaCustomersFeatureFlag,
  checkInternalInboxFeatureFlag,
  checkMarketingOverviewV2FeatureFlag,
  checkMenuFixerAgentFeatureFlag,
  checkMenuScorecardFeatureFlag,
  checkPhoneOrderingFeatureFlag,
  checkSalesFeatureFlag,
  checkLaunchFeatureFlag,
  ensureLocationIdParam,
]

router.beforeEach(async (to, from) => {
  for (const guard of guards) {
    const redirect = await guard(to, from)
    if (redirect) return redirect
  }
})

router.afterEach((to) => {
  if (to?.name && typeof to.name === 'string') sendPageLoad(to.name)
})
